module.exports = __webpack_public_path__ + "img/Logo.2b13d512.jpg";